import { useEffect, useMemo, useState } from "react";
import { PaginationParamType } from "type";
import { getCsvApi, getCsvDownloadApi, uploadCsv } from "../api/csvApi";
import { Csv, CsvDownload } from "../types/csv";

const DEFAULT_LIMIT_ITEMS = 30;

/**
 * Hook for page Csv
 */
export default function useCsv() {
  const [csvList, setCsvList] = useState<Csv[]>([]);
  const [csvDownload, setCsvDownload] = useState<CsvDownload>();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const totalPage = useMemo(() => Math.ceil(total / DEFAULT_LIMIT_ITEMS), [total]);

  const getCsv = async (body?: PaginationParamType) => {
    try {
      const data = await getCsvApi(body);
      if (body && body?.offset > 1) {
        setCsvList((prev) => [...prev, ...data.list]);
      } else {
        setCsvList(data.list);
      }
      setTotal(data.total);
    } finally {
      setLoading(false);
    }
  };

  const getCsvDownload = async () => {
    try {
      const data = await getCsvDownloadApi();
      setCsvDownload(data);
    } finally {
      setLoading(false);
    }
  };

  const handleUploadCsv = async (file: File, type: string) => {
    let res;
    try {
      res = await uploadCsv(file, type);
      // if (res.status === 200) {
      getCsvDownload();
      getCsv({ limit: DEFAULT_LIMIT_ITEMS, offset: 1 });
      // }
    } finally {
      setLoading(false);
    }
    return res;
  };

  useEffect(() => {
    getCsv({ limit: DEFAULT_LIMIT_ITEMS, offset: 1 });
    getCsvDownload();
  }, []);

  const onLoadMore = async () => {
    if (page + 1 > totalPage || csvList.length === total) return;
    setLoading(true);
    setPage((prevPage) => prevPage + 1);
    await getCsv({ limit: DEFAULT_LIMIT_ITEMS, offset: page + 1 });
  };

  return {
    csvList,
    csvDownload,
    total,
    totalPage,
    page,
    loading,
    onLoadMore,
    handleUploadCsv,
    getCsv,
  };
}
